function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import hexToRgba from "hex-to-rgba";
import isEqual from "lodash/isEqual";
import { TouchableOpacity } from "react-native";
import { Text } from "./Text";
import { View } from "./View";
import { AccessibleInput } from "../hooks/useAccessibleInput";
import { useTheme } from "../styles";
/**
 * Shows the user a group of options that can be selected.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-107}
 */ export function PillGroup(_param) {
    var disabled = _param.disabled, items = _param.items, onChangeValue = _param.onChangeValue, value = _param.value, props = _object_without_properties(_param, [
        "disabled",
        "items",
        "onChangeValue",
        "value"
    ]);
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(AccessibleInput, _object_spread_props(_object_spread({}, props), {
        children: function(accessibleProps) {
            return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({}, accessibleProps), {
                role: "radiogroup",
                spacing: 15,
                row: true,
                style: {
                    justifyContent: 'space-evenly'
                },
                children: items.map(function(item) {
                    var selected = isEqual(value, item.value);
                    return /*#__PURE__*/ _jsx(TouchableOpacity, {
                        testID: props.testID ? "".concat(props.testID, "_").concat(item.value) : undefined,
                        disabled: disabled,
                        role: "radio",
                        onPress: function() {
                            return onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(item.value);
                        },
                        "aria-selected": selected,
                        style: [
                            {
                                paddingHorizontal: 14,
                                paddingVertical: 12,
                                borderRadius: 10
                            },
                            selected ? {
                                backgroundColor: hexToRgba(theme.color.primary300, 0.3)
                            } : null
                        ],
                        children: /*#__PURE__*/ _jsx(Text, {
                            text: item.label,
                            weight: "semibold",
                            size: 15,
                            color: selected ? theme.color.primary100 : theme.color.gray400
                        })
                    }, item.key || item.label);
                })
            }));
        }
    }));
}
